import React from "react";
import { useTranslation } from "react-i18next";
const StomaPage = () => {
  const { t } = useTranslation();
  const image = "/images/mo/jangrucont/장루.png";
  return (
    <>
      <img src={image} alt="image" className="w-full" />

      <div className="pt-[16px] body_1_400_jangrucont">
        <div className=" subtitle_1_700">{t('StomaPage_title1', '1) 회장루')}</div>
        <span className="inline-block">{t('StomaPage_item1_1', '1. 변이 묽은 상태로 배출')}</span>
        <div className="flex ">
          <span className="inline-block">{t('StomaPage_item1_2_prefix', '2. ')}</span>

          <span className="inline-block">
            {t('StomaPage_item1_2', '소화효소가 포함되어 피부손상 시킬 수 있으므로 피부 관리에 주의해야 합니다.')}
          </span>
        </div>
        <div className="subtitle_1_700 pt-[32px]">{t('StomaPage_title2', '2) 상행결장루')}</div>
        <span className="inline-block">{t('StomaPage_item2_1', '1. 변이 묽은 상태로 배출')}</span>
        <div className="flex ">
          <span className="inline-block">{t('StomaPage_item2_2_prefix', '2. ')}</span>
          <span className="inline-block">
            {t('StomaPage_item2_2', '소화효소가 포함되어 피부손상 시킬 수 있으므로 피부 관리에 주의해야 합니다.')}
          </span>
        </div>
        <div className="subtitle_1_700 pt-[32px]">{t('StomaPage_title3', '3) 횡행결장루')}</div>
        <span className="inline-block">
          {t('StomaPage_item3', '변이 굳은 편이나 음식물에 따라 묽은 변이 배출되기도 합니다.')}
        </span>
        <div className="subtitle_1_700 pt-[32px]">{t('StomaPage_title4', '4) 하행/에스 결장루')}</div>
        <span className="inline-block">{t('StomaPage_item4_1', '1. 변이 굳은 상태로 배출')}</span>
        <div className="flex ">
          <span className="inline-block">{t('StomaPage_item4_2_prefix', '2. ')}</span>
          <span className="inline-block">
            {t('StomaPage_item4_2', '변비 예방을 위해 충분한 수분과 섬유소 섭취를 합니다.')}
          </span>
        </div>
      </div>
    </>
  );
};

export default StomaPage;
